import { CONTROL, PayloadsType, TEST } from '../utils/types';

export const Name = 'dynamic-llp-faqs';
export const Payloads: PayloadsType<boolean> = {
  [CONTROL]: false,
  [TEST]: true,
};

export const BootstrapVariant = CONTROL;
